module.exports = __webpack_public_path__ + "static/media/kick_off_fall_2023_500.d6fe7232.png";